import React from "react";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import Modal from "./Modal";

/**
 * Shown when Events/checkEventLimit reports EventLimitReached, mirroring the
 * mobile app's native alert with Cancel / Send Request buttons.
 */
const EventLimitModal = ({ message, onClose, onSendRequest, sending = false }) => {
  const { t } = useTranslation("common");
  return (
    <Modal
      title={t("eventLimitModal.title")}
      onClose={onClose}
      busy={sending}
      maxWidth={420}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={sending}>{t("actions.cancel")}</Button>
          <Button onClick={onSendRequest} disabled={sending}>{sending ? t("eventLimitModal.sending") : t("eventLimitModal.sendRequest")}</Button>
        </>
      }
    >
      <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.55 }}>
        {message || t("eventLimitModal.defaultMessage")} {t("eventLimitModal.messageSuffix")}
      </p>
    </Modal>
  );
};

export default EventLimitModal;
